<template>
  <div class="protocol-popup">
    <div class="protocol-content" v-if="protocolType === 'content'" v-html="protocolContent"></div>
    <div v-else>
      <iframe id="modle_iframe" :src="protocolUrl" frameborder="0" style="height: 8.5rem"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'protocolPopup',
  props: {
    protocolType: {
      type: String,
      default: '',
    },
    protocolUrl: {
      type: String,
      default: '',
    },
    protocolContent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.protocol-popup {
  margin-top: 0.2rem;
  width: 100%;
  height: 100% !important;
  border-radius: 0.12rem;
  background-color: #f3f5f9 !important;
  overflow-y: scroll !important;
  padding-bottom: 0.2rem;
}

#modle_iframe {
  width: 100%;
  height: 100%;
}
.protocol-content {
  height: 9rem;
  padding: 0.2rem;
  overflow-y: scroll;
}
</style>
